<template>
    <div class="layout-footer">
        <span>Copyright © {{ new Date().getFullYear() }}
            <RouterLink :to="{ name: 'dashboard' }">
                Enim {{ $t('general.administration') }}
            </RouterLink>, All rights Reserved
        </span>
    </div>
</template>

<script setup lang="ts">
</script>
